import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { getAppPortalRoot } from "../utils/appPortal";
import RewardWheel from "./RewardWheel";
import "./RewardWheel.css";

export default function RewardWheelModal({
  open = false,
  wheelType,
  cloverPotionId,
  stockQuantity = 1,
  onClose,
  onSpinComplete,
}) {
  const cancelRequestRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  if (!open) return null;

  const handleWheelDismiss = () => {
    onClose?.();
  };

  const handleCloseAttempt = () => {
    if (cancelRequestRef.current) {
      cancelRequestRef.current();
      return;
    }
    onClose?.();
  };

  return createPortal(
    <div
      className="reward-wheel-modal-backdrop"
      onClick={handleCloseAttempt}
      role="presentation"
    >
      <div
        className="reward-wheel-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="reward-wheel-modal-title"
      >
        <button
          type="button"
          className="reward-wheel-modal__close"
          onClick={handleCloseAttempt}
          aria-label="Fermer"
        >
          ×
        </button>
        <RewardWheel
          wheelType={wheelType}
          cloverPotionId={cloverPotionId}
          stockQuantity={stockQuantity}
          onPrepared={onSpinComplete}
          onSpinComplete={onSpinComplete}
          onDismiss={handleWheelDismiss}
          onRegisterCancelRequest={(handler) => {
            cancelRequestRef.current = handler;
          }}
        />
      </div>
    </div>,
    getAppPortalRoot()
  );
}
